var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30.000000pt",
    height: "30.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523 4945 c-170 -46 -304 -181 -348 -350 -11 -45 -15 -115 -15 -292 l0 -233 2400 0 2400 0 0 224 c0 123 -5 247 -10 277 -25 129 -125 267 -238 327 -124 66 26 62 -2157 61 -1671 0 -1988 -3 -2032 -14z m463 -451 c44 -21 84 -88 84 -140 0 -47 -34 -107 -76 -134 -42 -28 -121 -27 -164 3 -55 37 -75 72 -75 132 0 60 20 95 75 133 40 27 106 29 156 6z m562 -4 c47 -29 72 -76 72 -135 0 -93 -62 -155 -156 -155 -157 0 -216 199 -84 287 43 30 121 31 168 3z m552 -3 c132 -88 73 -287 -85 -287 -154 0 -214 199 -86 286 48 32 124 33 171 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 2167 c0 -1371 2 -1590 15 -1640 47 -179 198 -323 374 -357 73 -14 3947 -14 4022 0 182 34 344 196 379 379 6 35 10 599 10 1627 l0 1574 -2400 0 -2400 0 0 -1583z m2692 1403 c588 -124 1027 -560 1160 -1151 31 -140 33 -455 4 -589 -101 -462 -385 -834 -793 -1039 -408 -205 -884 -211 -1292 -15 -426 204 -720 573 -823 1034 -20 91 -23 132 -23 305 0 173 3 214 23 304 90 402 312 722 655 945 184 120 406 199 647 230 83 10 347 -4 442 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2505 3266 c-82 -35 -207 -229 -264 -406 -50 -158 -101 -428 -101 -537 l0 -43 420 0 420 0 0 43 c0 23 -9 102 -20 176 -46 316 -139 562 -262 697 -74 80 -126 99 -193 70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3139 3073 c82 -192 161 -559 161 -744 l0 -49 205 0 c168 0 205 2 205 14 0 33 -52 208 -84 284 -88 210 -277 424 -478 542 l-38 22 29 -69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1902 3074 c-167 -114 -331 -313 -409 -496 -32 -75 -83 -250 -83 -284 0 -11 38 -14 205 -14 l205 0 0 49 c0 186 82 564 164 753 28 64 23 64 -82 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410 1951 c0 -5 7 -41 15 -79 60 -287 247 -563 489 -721 43 -28 81 -50 82 -48 2 2 -14 51 -36 110 -69 182 -119 420 -138 652 l-7 90 -202 3 c-124 1 -203 -1 -203 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2140 1913 c0 -79 37 -307 70 -431 74 -278 198 -483 313 -521 133 -44 294 174 388 526 32 119 69 348 69 426 l0 47 -420 0 -420 0 0 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3306 1948 c-3 -7 -7 -51 -10 -98 -16 -212 -68 -457 -136 -637 -22 -59 -38 -108 -36 -111 10 -9 155 97 230 168 174 165 294 376 341 602 8 38 15 74 15 79 0 15 -400 12 -404 -3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.c36b744ab36f9be5abf93de3eeab230b.svg";
export { ForwardRef as ReactComponent };